import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { GridApi } from 'ag-grid-community';
import { ServerDashboardDashboard, ServerDashboardJob } from './dashboardType';

export const dashboardAtom = atom<ServerDashboardDashboard | null>(null);

export const selectedRowsAtom = atom<ServerDashboardJob[]>([]);

export const dashboardClientAPIAtom = atom<GridApi | null>(null);

export const statusButtonsVisibleAtom = atomWithStorage(
  'dashboard-status-buttons-visible',
  true
);
